import _ from 'lodash';

import api from '../api';

const ACCOUNT_GET_SUCCESS = api.events.accountsGet.actionSuccess;
const ACCOUNT_LIST_SUCCESS = api.events.accountsList.actionSuccess;
const ACCOUNT_PATCH_SUCCESS = api.events.accountsPatch.actionSuccess;
const ACCOUNT_DISCHARGE_SUCCESS = api.events.accountsDischarge.actionSuccess;

const defaultState = { all: [] };

export default function auth(state = defaultState, action) {
  switch (action.type) {
    case ACCOUNT_LIST_SUCCESS:
      return { ...state, all: action.data };
    case ACCOUNT_DISCHARGE_SUCCESS:
    case ACCOUNT_PATCH_SUCCESS:
    case ACCOUNT_GET_SUCCESS:
      return {
        ...state,
        all: _.unionBy([action.data], state.all, account => account.id)
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accounts.js